// extracted by mini-css-extract-plugin
export default {"root":"RequiresRequest_root__w4xCK"};